<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        small
        icon
        color="primary"
        v-on="on"
      >
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Cost Center"
      text="Update Employee Cost Center"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row no-gutters>
          <v-col
            cols="12"
            class="mt-3"
          >
            <v-autocomplete 
              v-model="localCostCenter.cost_center" 
              label="Cost Center"
              :items="costCenters"
              item-text="name"
              item-value="id"
              outlined
              return-object
            />
          </v-col>
          
          <v-col cols="12">
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startDateDisplay"
                  v-validate="'required'"
                  :error-messages="errors.collect('startDateDisplay')"
                  data-vv-name="startDateDisplay"
                  data-vv-as="start date"
                  label="Start date"
                  readonly
                  outlined
                  class="label-position"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="localCostCenter.start_date"
                no-title
                :min="minStartDate"
                :max="localCostCenter.end_date"
                @input="startDateMenu = false"
              />
            </v-menu> 
          </v-col>

          <v-col
            v-if="costCenter.end_date"
            cols="12"
          >
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endDateDisplay"
                  v-validate="'required'"
                  :error-messages="errors.collect('endDateDisplay')"
                  data-vv-name="endDateDisplay"
                  data-vv-as="end date"
                  label="End date"
                  readonly
                  outlined
                  class="label-position"
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="localCostCenter.end_date"
                no-title
                :min="localCostCenter.start_date"
                :max="maxEndDate"
                @input="endDateMenu = false"
              />
            </v-menu> 
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          class="px-10"
          :disabled="progressing"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="hrissecondary"
          class="px-10 white--text"
          :loading="progressing"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      costCenter: {
        type: Object,
        default: null,
        required: true,
      },
      companyUid: {
        type: String,
        default: null,
        required: true,
      },
      minStartDate: {
        type: String,
        required: true,
      },
      maxEndDate: {
        type: String,
        required: true,
      },
    },

    data () {
      return {
        dialog: false,
        progressing: false,
        costCenters: [],
        startDateMenu: false,
        endDateMenu: false,
        localCostCenter: null,
      }
    },

    computed: {
      startDateDisplay () {
        return this.localCostCenter.start_date ? this.$moment(this.localCostCenter.start_date, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
      endDateDisplay () {
        return this.localCostCenter.end_date ? this.$moment(this.localCostCenter.end_date, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
    },

    watch: {
      dialog: function (val) {
        if (val) {
          this.$api.costCenters().list(this.companyUid)
            .then(response => {
              this.costCenters = _.orderBy(response.data, ['name'], ['asc'])
            })
            .catch(e => {})
            .then(res => {
            })

          this.localCostCenter = { ...this.costCenter }
        } else {
          this.$validator.reset()
        }
      },
    },

    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            
            this.$api.companyEmployeeCostCenters().update(this.costCenter.id, this.prepareFormData())
              .then(res => {
                this.$emit('updated')
                this.$snack({ message: res.data.status })

                this.dialog = false
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return { 
          'cost_center_id': this.localCostCenter.cost_center.id,
          'start_date': this.localCostCenter.start_date,
          'end_date': this.costCenter.end_date ? this.localCostCenter.end_date : null,
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
